import { AxiosRequestConfig } from 'axios';

import { Result } from '@src/api/types';

import Client from './client';
import { SubscriptionId } from './enums';

type Response = {
  readonly result: Result;
  readonly status: number;
};

type Data = {
  packageName: string;
  purchaseToken: string;
  subscriptionId: SubscriptionId;
};

export default (planId: string, data: Data, config?: AxiosRequestConfig) => {
  return Client.post<Response>(
    `/ps/v1/plans/bazar/pay/${planId}`,
    data,
    config
  );
};
